export const STATUS = {
  IN_PROGRESS: "in-progress",
  DONE: "done",
  TO_DO: "to-do",
};
